module.exports = __webpack_public_path__ + "img/top3_right.b485e52a.png";